module.exports = __webpack_public_path__ + "media/images/book-img-05-0a71c771ed35883fd2a0e7838944be23.png";